<!-- Lista recomendacoes -->
<p class="text-center" ng-show="recommendations && !recommendations.length && !loading">
  <small>Nenhuma Recomendação...</small>
</p>

<span class="input-group-addon no-border no-background" ng-show="loading">
  <i class="fa fa-spinner fa-spin"></i>
</span>

<uib-accordion close-others="true" class="list-recomendacoes" id="list-recommendation-history" ng-show="recommendations.length && !loading">
  <div infinite-scroll="getRecommendations()"
       infinite-scroll-parent="true"
       infinite-scroll-immediate-check="false">
    <uib-accordion-group
         class="panel-default panel-{{recommendation.status.color}} {{recommendation.status.color}} {{recommendation.emAndamento ? 'striped' : ''}} {{recommendation.emAndamentoAtrasada ? 'striped-danger' : ''}}"
         is-open="recommendation.open" ng-repeat="recommendation in recommendations">
      <uib-accordion-heading>
        <div class="checkbox pull-left">
          <label>
            <input ng-click="checkRecommendation($event)" ng-model="recommendation.checked" type="checkbox">
          </label>
        </div>
        <div ng-click="openRecommendationDetail($event, recommendation)">
          <i class="pull-right fa fa-2x" ng-hide="recommendation.loading"
             ng-class="{'fa-minus-circle': recommendation.open, 'fa-plus-circle': !recommendation.open}">
          </i>
          <span ng-show="recommendation.loading">
            <i class="pull-right fa fa-2x fa-spinner fa-spin"></i>
          </span>

          <!-- Glebas: Somente visivel quando não for filtrado -->
          <span ng-hide="recommendationFilters.gleba">{{::recommendation.glebas | getTextItems}}</span>
          <br ng-hide="recommendationFilters.gleba">

          {{::recommendation.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
          <br>
          <small class="text-white">
            <i class="fa fa-calendar"></i>
            {{::recommendation.data_inicio | date:'dd/MM'}} à {{::recommendation.data_termino | date:'dd/MM'}}
          </small>
        </div>
        <div class="clearfix"></div>
      </uib-accordion-heading>

      <p ng-if="recommendation.allData.situacao == 'rejeitado'" class="text-center">
        <strong>Recomendação rejeitada</strong>
        <br>
        {{::recommendation.allData.motivo_rejeicao}}
      </p>

      <p ng-if="recommendation.allData.situacao == 'aguardando_aprovacao'" class="text-center">
        <strong>Aguardando aprovação</strong>
      </p>

      <p>
        <strong>Código: </strong>
        {{::recommendation.id}} <br>
        <strong>Previsto: </strong>
        {{::recommendation.allData.data_inicio | date:'dd/MM/yyyy'}}  até {{::recommendation.allData.data_termino | date:'dd/MM/yyyy'}}
        <br>
        <strong>Área Recomendada: </strong>
        {{::recommendation.allData.area_total_recomendada | number:2}} ha
        <br>
        <strong>Área Aplicada: </strong>
        {{::recommendation.allData.area_total_aplicada | number:2}} ha
        <br>
        <strong>Concluído: </strong>
        {{recommendation.allData.percentual_concluido | number:1}} %
        <br>
        <strong>Recomendante: </strong>
        {{::recommendation.allData.recomendante.nome_completo | capitalize}}
        <br>
        <strong>Cultura: </strong>
        {{::recommendation.allData.atividade.descricao | capitalize}}
        <br>
        <strong>Vazão: </strong>
        {{::recommendation.allData.vazao | number}} l/ha
        <br>
        <strong>Litros/Min: </strong>
        {{::recommendation.allData.litros_minutos}}
        <br>
        <strong ng-if="recommendation.allData.periodo.descricao">Período: </strong>
        {{::recommendation.allData.periodo.descricao | capitalize}}
        <br>
        <strong ng-if="recommendation.allData.bico">Bico: </strong>
        {{::recommendation.allData.bico | capitalize}}
        <br>
        <strong ng-if="recommendation.allData.observacao">Observações: </strong>
        {{::recommendation.allData.observacao | capitalize}}
      </p>

      <div ng-repeat="gleba in ::recommendation.allData.glebas">
        <div ng-if="!recommendationFilters.gleba || recommendationFilters.gleba.id == gleba.id">
          <hr class="hr-sm">

          <strong>{{gleba.descricao}}</strong> ({{gleba.area_total | number:2}}ha)

          <strong ng-show="gleba.aplicada && recommendation.status.descricao != 'aplicada'"> - Já aplicada</strong>
          <strong ng-show="!gleba.aplicada && gleba.percentual_aplicado > 0"> - Aplicado em {{gleba.percentual_aplicado | number:1}}%</strong>

          <dl>
            <dt ng-repeat-start="produto in recommendation.allData.insumos track by $index" class="text-light pull-left">
              {{::produto.descricao}}
            </dt>
            <dd class="pull-right text-right dose-total">
              <strong>{{produto.dose | formatDynamicDecimals}}</strong> <span class="text-light">{{::produto.unidade.abreviatura}}/ha</span><br>
              <small><span class="text-light">Total:</span> {{calculateTotalProduto(produto, gleba.area_total, recommendation.allData.glebas.length > 1) | formatDynamicDecimals}}</small> {{::produto.unidade.abreviatura}}
            </dd>
            <div ng-repeat-end class="clearfix"></div>
          </dl>
        </div>
      </div>

      <a class="text-white" ng-if="canEditRecommendation(recommendation)"
         ng-click="concludeRecommendation(recommendation)">
        Encerrar recomendação
        <br>
      </a>
      <span ng-show="recommendation.waiting">
        <i class="pull-right fa fa-spinner fa-spin"></i>
      </span>

      <div class="text-right">
        <span class="btn" ng-click="showModalImpressao(recommendation.allData)" uib-tooltip="Imprimir">
          <i class="fa fa-print" aria-hidden="true"></i>
        </span>
        <a class="text-white" ng-click="editRecommendation(recommendation.allData)">
          <u><i class="fa fa-cog" aria-hidden="true" ></i>Editar</u>
        </a>
      </div>
    </uib-accordion-group>
  </div>
  <div class="clearfix"></div>
</uib-accordion>
